import React, { useEffect } from "react";
import { Box, Card, Typography } from "@mui/material";
import ClaimsStyles from "../../customers/PolicyDetails/policyTabComponents/Claims/ClaimsStyles";
import { activeClaims, pastClaims } from "../../constants/Constants";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getClaimsData } from "../../../src/customers/Dashboard/DashboardAction";
import ClaimCard from "../../../src/customers/Dashboard/Claims/ClaimCard/ClaimCard";
import { RootState } from "../../../src/store/store";
import { IClaim } from "../../../src/models/user/dashboard/Dashboard";
import CustomIcon from "../../../src/common/CustomIcon/CustomIcon";
import { useTranslation } from "react-i18next";
import CustomSkeleton from "../../../src/common/CustomSkeleton/CustomSkeleton";
import { getCookie } from "../../utils/Utility";
import { useParams } from "react-router-dom";

const ClaimHistory: React.FC = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const { isLoading, calledReducerType } = useAppSelector(
    (store: RootState) => store.common
  );
  const { customerId } = useParams();
  // const { userDetails } = useAppSelector((state: RootState) => state.userAuth);
  const { claimsData } = useAppSelector((state: RootState) => state.dashboard);
  const { policyDetailsHeader } = useAppSelector(
    (state: RootState) => state.policyDetails
  );
  const carrier = getCookie("carrier");
  const system = getCookie("system");

  console.log("claimsData", claimsData);
  console.log("policyDetailsHeader", policyDetailsHeader?.carrierPolicyNumber);

  const getActiveClaims = () => {
    if (claimsData && claimsData.claimList && claimsData.claimList.length > 0) {
      return claimsData.claimList
        ?.filter((claim: IClaim) => claim.carrierClaimStatus !== "Closed")
        .map((claim: IClaim) => (
          <ClaimCard
            claim={claim}
            key={`policy-tab-claim-active-${claim.carrierClaimNo}`}
          />
        ));
    } else {
      return [];
    }
  };

  const getPastClaims = () => {
    if (claimsData && claimsData.claimList && claimsData.claimList.length > 0) {
      return claimsData.claimList
        ?.filter((claim: IClaim) => claim.carrierClaimStatus === "Closed")
        .map((claim: IClaim) => (
          <ClaimCard
            claim={claim}
            key={`policy-tab-claim-past-${claim.carrierClaimNo}`}
          />
        ));
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (customerId && carrier && system) {
      dispatch(
        getClaimsData({
          customerId: customerId,
          carrier: carrier,
          system: system,
        })
      );
    }
  }, [dispatch]);

  return (
    <>
      {isLoading && calledReducerType === "dashboard/getClaimsData" ? (
        <CustomSkeleton 
          direction="column" 
          height="120px" 
        />
      ) : (
        <Box 
          id="claim-history-container"
          data-test-id="test-claim-history-container"
          aria-label="Claims history container"
          sx={ClaimsStyles.container}
        >
          <Box
            id="claim-history-active-claims"
            data-test-id="test-claim-history-active-claims"
            aria-label="Active claims section"
            sx={ClaimsStyles.activeClaimsContainer}
          >
            <Box 
              id="claim-history-active-title-box"
              data-test-id="test-claim-history-active-title-box"
              aria-label="Active claims title container"
              sx={ClaimsStyles.titleBox}
            >
              <CustomIcon iconName="ActiveClaims" />
              <Typography 
                id="claim-history-active-title"
                data-test-id="test-claim-history-active-title"
                aria-label="Active claims title"
                sx={ClaimsStyles.titleText}
              >
                {t(activeClaims)}
              </Typography>
            </Box>
            {getActiveClaims().length > 0 ? (
              getActiveClaims()
            ) : (
              <Card 
                id="claim-history-active-no-claims"
                data-test-id="test-claim-history-active-no-claims"
                aria-label="No active claims message"
                sx={ClaimsStyles.noClaimsCard}
              >
                <Typography 
                  id="claim-history-active-no-claims-text"
                  data-test-id="test-claim-history-active-no-claims-text"
                  aria-label="No active claims available text"
                  sx={ClaimsStyles.noClaimsText}
                >
                  {t("No Claims Available")}
                </Typography>
              </Card>
            )}
          </Box>
          <Box
            id="claim-history-past-claims"
            data-test-id="test-claim-history-past-claims"
            aria-label="Past claims section"
            sx={ClaimsStyles.activeClaimsContainer}
          >
            <Box 
              id="claim-history-past-title-box"
              data-test-id="test-claim-history-past-title-box"
              aria-label="Past claims title container"
              sx={ClaimsStyles.titleBox}
            >
              <CustomIcon iconName="PastClaims" />
              <Typography 
                id="claim-history-past-title"
                data-test-id="test-claim-history-past-title"
                aria-label="Past claims title"
                sx={ClaimsStyles.titleText}
              >
                {t(pastClaims)}
              </Typography>
            </Box>
            {getPastClaims().length > 0 ? (
              getPastClaims()
            ) : (
              <Card 
                id="claim-history-past-no-claims"
                data-test-id="test-claim-history-past-no-claims"
                aria-label="No past claims message"
                sx={ClaimsStyles.noClaimsCard}
              >
                <Typography 
                  id="claim-history-past-no-claims-text"
                  data-test-id="test-claim-history-past-no-claims-text"
                  aria-label="No past claims available text"
                  sx={ClaimsStyles.noClaimsText}
                >
                  {t("No Claims Available")}
                </Typography>
              </Card>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default ClaimHistory;
